import React from "react";
import { Database } from "lucide-react";
import { motion } from "framer-motion";

export const TechnologyHero = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="text-center mb-16 pt-8"
    >
      <h1 
        className="text-4xl sm:text-6xl font-bold mb-6 tracking-tight leading-tight text-white"
        aria-label="The Science Behind Every Conversation"
      >
        The Science Behind
        <br />
        Every Conversation
      </h1>
      <p 
        className="text-lg sm:text-2xl text-gray-200 max-w-3xl mx-auto mb-12 leading-relaxed font-light"
        aria-label="Platform description"
      >
        Transforming routine healthcare calls into powerful health insights through voice AI and clinically validated speech biomarkers.
      </p>
    </motion.div>
  );
};